import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  gatewayFormValidator,
  gatewayFormValidatorWithCustomErrors,
  VALIDATORS,
} from "../../../../utils/gatewayFormValidator";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import QRCodeCard from "../../../../utils/QrCodeCard";
import {
  updateDepositAmount,
  createDeposit,
  getOneGateway,
  getAllGateways,
  createDynamicManualWithdrawRequest,
  requestWithdrawOtp,
} from "../../../../redux/user/actions";
import { APP_CONST, BankModeRequiredFields } from "../../../../config/const";
import { Toaster } from "../../../../utils/toaster";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import Footer from "../../../../containers/Footer";
import { Container, Tab, Tabs } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import DepositImg from "../../../../assets/images/icons/dc.png";
import bankImg from "../../../../assets/images/icons/bank.png";
import { getActiveBankDetails } from "../../../../redux/app/actions";
// import CopyToClipboard from "../../../components/copyToClipBoard";
import CopyToClipboard from "react-copy-to-clipboard";
import { AiFillCopy } from "react-icons/ai";
import BackIcon from "../../../../assets/svg/BackIcon";
import DisplayValues from "../../../components/gateways/DisplayValues";
import { getSortedArray } from "../../../../utils/array.utils";
import GatewayFields from "../../../components/gateways/GatewayFields";
import ListBankDetails from "../withdraw/listBankDetails";
import PlayerBankDetailsForm from "../playerBankDetails";
import PreWithdrawForm from "../../../components/gateways/PreWithdrawForm";

const AccSelectionModes = {
  Auto: "auto",
  Manual: "manual",
  AddAccount: "addAccount",
};

const ACC_SELECTION_TABS = [
  { id: 0, name: "Add Bank Details", key: AccSelectionModes.AddAccount },
  { id: 1, name: "Select bank", key: AccSelectionModes.Auto },
  { id: 2, name: "Manual", key: AccSelectionModes.Manual },
];

const DepositGateway = () => {
  const navigate = useNavigate();
  const [selectedGateway, setSelectedGateway] = useState(null);
  const { bankDetails } = useSelector((state) => state.app);
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({});
  const [formdata, setFormdata] = useState({});
  const [errors, setErrors] = useState({});
  const { type } = useParams();
  const [gtwList, setGtwList] = useState([]);
  const [gatewaysList, setGatewaysList] = useState([]);
  const [clickedGatway, setClickedGatway] = useState("bank_transfer");
  const isBank = clickedGatway === "bank_transfer";
  const showQrImg = selectedGateway?.qrCode !== null;
  const [isCreatingDeposit, setIsCreatingDeposit] = useState(false);
  const [mainTab, setMainTab] = useState("deposits");
  const [subTab, setSubTab] = useState("bank");
  const [isRequesting, setIsRequesting] = useState(false);

  // withdraw gateways local states
  const [gtw, setGtw] = useState(null);
  const { wallet } = useSelector((state) => state?.auth);
  const [clickedWTDGatway, setWTDClickedGatway] = useState();
  const [withdrawOtpConfig, setWithdrawOtpConfig] = useState({
    otpRequired: false,
    otpSent: false,
    isSendingOtp: false,
    otpValue: "",
    otpSubmitted: false,
  });
  const [activeAccSelectionMode, setActiveAccSelectionMode] = useState(
    AccSelectionModes.Auto
  );
  const [playerBankDetails, setPlayerBankDetails] = useState(null);
  const [isBankMode, setIsBankMode] = useState(false);

  useEffect(() => {
    if (
      clickedGatway &&
      clickedGatway !== "bank_transfer" &&
      mainTab === "deposits"
    ) {
      getOneGtwFromServer(clickedGatway?.id || clickedGatway);
    }
  }, [clickedGatway]);

  // default load on inital render
  useEffect(() => {
    loadGtwsFromServer();
    dispatch(getActiveBankDetails());
  }, []);

  useEffect(() => {
    if (type === "deposits") {
      setMainTab("deposits");
      setSubTab("bank");
    }
  }, [type]);

  useEffect(() => {
    if (type === "withdraw") {
      setMainTab("withdraws");
      setSubTab("withdraw");
      if (gtwList?.length > 0) {
        setWTDClickedGatway(gtwList[0]?.id);
        getOneWTDGtwFromServer(gtwList[0]?.id);
      }
    }
  }, [type, gtwList]);

  /**
   *
   * @param {string} gateway
   */
  const getOneGtwFromServer = async (gateway) => {
    const response = await getOneGateway(gateway);
    if (response && response?.data?.data?.data) {
      setSelectedGateway(response?.data?.data?.data);
    }
  };

  const validateData = (dataToValidate) => {
    const amountValidation = [];

    if (selectedGateway?.depositSettings?.min) {
      amountValidation.push({
        validationValue: selectedGateway?.depositSettings?.min,
        type: VALIDATORS.Min,
        customMessage: `Min allowed amount is ${selectedGateway?.depositSettings?.min}`,
      });
    }

    if (selectedGateway?.depositSettings?.max) {
      amountValidation.push({
        validationValue: selectedGateway?.depositSettings?.max,
        type: VALIDATORS.Max,
        customMessage: `Max allowed amount is ${selectedGateway?.depositSettings?.max}`,
      });
    }

    let fields = selectedGateway?.fields;
    let validations = gatewayFormValidatorWithCustomErrors({
      fields: fields,
      dataToValidate: dataToValidate,
      cstmValidation: {
        amount: amountValidation,
      },
    });
    setErrors(validations);
    return validations;
  };

  const validateBankFormData = (data) => {
    const { amount, utrNo, txnImage } = data;
    let errorVar = {};
    if (!amount) {
      errorVar.amount = "Amount is required";
    }
    if (!utrNo) {
      errorVar.utrNo = "UTR is required";
    }
    if (!txnImage) {
      errorVar.txnImage = "Txn image is required";
    }
    setErrors(errorVar);
    return errorVar;
  };

  const handleChange = (e, type = "non-file") => {
    let name = e.target.name;
    let value = e.target.value;
    if (type === "file") {
      value = e.target.files?.[0];
    }
    let data = { ...formData, [name]: value };
    if (isBank) {
      validateBankFormData(data);
    } else {
      validateData(data);
    }

    setFormData(data);
  };

  const getIfDefaultValue = ({ data }) => {
    let updatedData = { ...data };
    selectedGateway?.fields.forEach((f) => {
      if (!Boolean(data[f?.accessor]) && Boolean(f?.value)) {
        updatedData[f?.accessor] = f?.value;
      }
    });
    return updatedData;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isBank) {
      if (Object.values(validateData({ ...formData })).length == 0) {
        setIsCreatingDeposit(true);
        // console.log("formData", formData);
        if (
          selectedGateway?.fields.some(
            (f) => f?.accessor === "gateway" && f?.required === true
          )
        ) {
          formData["gateway"] = selectedGateway?.code;
        }
        if (selectedGateway?.slug && selectedGateway?.slug !== null) {
          formData.slug = selectedGateway?.slug;
        }

        const dataWithDefaultValues = getIfDefaultValue({ data: formData });
        const response = await updateDepositAmount({
          data:
            selectedGateway?.url.indexOf("dynamicmanual") > -1
              ? {
                  amount: dataWithDefaultValues?.amount,
                  slug: dataWithDefaultValues?.slug,
                  dynamicFields: dataWithDefaultValues,
                }
              : dataWithDefaultValues,
          url: selectedGateway?.url,
          isMultiPart: selectedGateway?.fields.some(
            (f) => f?.type === "file" || f?.type === "image"
          ),
        });
        setIsCreatingDeposit(false);
        handleSubmitResponse(response);
        // console.log("response", response);
      }
    } else {
      if (Object.values(validateBankFormData(formData)).length === 0) {
        setIsCreatingDeposit(true);
        createDeposit(formData)
          .then((res) => {
            setIsCreatingDeposit(false);
            Toaster(APP_CONST.TOAST_TYPE.SUCCESS, res.data.data.message);
          })
          .catch((err) => {
            setIsCreatingDeposit(false);
            Toaster(APP_CONST.TOAST_TYPE.ERROR, err.response.data.message);
          });
      }
    }
  };

  const handleSubmitResponse = (value) => {
    if (value) {
      if (
        selectedGateway?.url.indexOf("dynamicmanual") > -1 &&
        value?.data?.data
      ) {
        Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Request created");
        navigate("/cashier");
      }
      if (selectedGateway?.type === "manual") {
        Toaster(APP_CONST.TOAST_TYPE.SUCCESS, value.data.data.message);
      } else if (value?.data?.data?.data && "payUrl" in value?.data.data.data) {
        window.location.href = value?.data?.data?.data?.payUrl;
      } else if (
        value?.data?.data?.data &&
        "payImageUrl" in value?.data.data.data
      ) {
        // setPaymentImage(value?.data?.data?.data?.payImageUrl);
      } else if (selectedGateway?.code === "alphapo") {
        window.location.href = value?.data?.data?.data?.url;
      }
    }
  };

  const renderFields = (field) => {
    switch (field.type) {
      case "file":
      case "image":
        return (
          <Form.Group
            className="mb-3 position-relative"
            controlId="formBasicUserName"
          >
            <Form.Control
              type={"file"}
              placeholder={field.label}
              name={field.accessor}
              onChange={(e) => handleChange(e, "file")}
              style={{ display: !field.display ? "none" : "" }}
              isInvalid={!!errors[field.accessor]}
            />
            <span class="focus-border">
              <i></i>
            </span>
            <Form.Control.Feedback type="invalid">
              {errors[field.accessor]}
            </Form.Control.Feedback>
          </Form.Group>
        );
      default:
        return (
          <Form.Group
            className="mb-3 position-relative"
            controlId="formBasicUserName "
          >
            <Form.Control
              type={field.type}
              placeholder={field.label}
              name={field.accessor}
              value={
                !Boolean(formData?.[field?.accessor]) &&
                formData?.[field?.accessor] !== "" &&
                field?.value
                  ? field?.value
                  : formData?.[field?.accessor]
              }
              onChange={handleChange}
              style={{ display: !field.display ? "none" : "" }}
              isInvalid={!!errors[field.accessor]}
            />
            <span class="focus-border">
              <i></i>
            </span>
            <Form.Control.Feedback type="invalid">
              {errors[field.accessor]}
            </Form.Control.Feedback>
          </Form.Group>
        );
    }
  };

  const renderBankTransferForm = () => {
    return (
      <Form className="gatewayForm">
        <Form.Group
          className="mb-3 position-relative"
          controlId="formBasicUserName"
        >
          <Form.Control
            type={"string"}
            value={"Bank Transfer"}
            disabled={true}
          />
          <span class="focus-border">
            <i></i>
          </span>
        </Form.Group>
        <Form.Group
          className="mb-3 position-relative"
          controlId="formBasicUserName"
        >
          <Form.Control
            type={"number"}
            placeholder={"Enter amount"}
            name={"amount"}
            onChange={(e) => handleChange(e)}
            // style={{ display: !field.display ? "none" : "" }}
            isInvalid={!!errors["amount"]}
          />
          <span class="focus-border">
            <i></i>
          </span>
          <Form.Control.Feedback type="invalid">
            {errors["amount"]}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group
          className="mb-3 position-relative"
          controlId="formBasicUserName"
        >
          <Form.Control
            type={"text"}
            placeholder={"Enter UTR no"}
            name={"utrNo"}
            onChange={(e) => handleChange(e)}
            // style={{ display: !field.display ? "none" : "" }}
            isInvalid={!!errors["utrNo"]}
          />
          <span class="focus-border">
            <i></i>
          </span>
          <Form.Control.Feedback type="invalid">
            {errors["utrNo"]}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group
          className="mb-3 position-relative"
          controlId="formBasicUserName"
        >
          <Form.Control
            type={"file"}
            placeholder={"Select file"}
            name={"txnImage"}
            onChange={(e) => handleChange(e, "file")}
            // style={{ display: !field.display ? "none" : "" }}
            isInvalid={!!errors["txnImage"]}
          />
          <span class="focus-border">
            <i></i>
          </span>
          <Form.Control.Feedback type="invalid">
            {errors["txnImage"]}
          </Form.Control.Feedback>
        </Form.Group>
        <Button onClick={handleSubmit}>Submit</Button>
      </Form>
    );
  };

  const handleGatewayClick = (item) => {
    // navigate(`/deposit/${item?.id}`);
    setClickedGatway(item?.id);
  };

  const handleBankTransferClick = () => {
    // navigate(`/deposit/bank_transfer`);
    setClickedGatway("bank_transfer");
  };

  const loadGtwsFromServer = async () => {
    const response = await getAllGateways();
    if (response && response?.data?.data?.data) {
      setGatewaysList(response?.data?.data?.data);
      const sortedArray = getSortedArray({
        arrayToBeSort: response?.data?.data?.data?.withdraws,
        sortKey: "order",
      });
      setGtwList(sortedArray);
    }
  };

  // Withdraw Functions ***************************************************************

  useEffect(() => {
    if (clickedWTDGatway) {
      getOneWTDGtwFromServer(clickedWTDGatway);
    }
  }, [clickedWTDGatway]);

  /**
   *
   * @param {string} gtwId
   */
  const getOneWTDGtwFromServer = async (gtw) => {
    const response = await getOneGateway(gtw);
    if (response && response?.data?.data?.data) {
      setGtw(response?.data?.data?.data);
      setWithdrawOtpConfig((p) => ({
        ...p,
        otpRequired:
          response?.data?.data?.data?.withdrawSettings?.otpRequired || false,
      }));
      /**@type {boolean} */
      const isBankMode = response?.data?.data?.data?.withdrawFields?.some(
        (s) => s?.accessor === "accountNo"
      );

      setIsBankMode(isBankMode);
    }
  };

  const validateWithdrawData = (dataToValidate = {}) => {
    let amountValidationArray = [
      {
        validationValue: wallet.cash,
        type: VALIDATORS.Max,
        customMessage: "Insufficient Balance",
      },
    ];

    if (gtw?.withdrawSettings?.min) {
      amountValidationArray.push({
        validationValue: gtw?.withdrawSettings?.min,
        type: VALIDATORS.Min,
        customMessage: `Min allowed amount is ${gtw?.withdrawSettings?.min}`,
      });
    }

    if (gtw?.withdrawSettings?.max) {
      amountValidationArray.push({
        validationValue: gtw?.withdrawSettings?.max,
        type: VALIDATORS.Max,
        customMessage: `Max allowed amount is ${gtw?.withdrawSettings?.max}`,
      });
    }

    let validatorPayload = {
      fields: gtw?.withdrawFields,
      dataToValidate: dataToValidate,
      // Custom validations for gateway form
      cstmValidation: {
        amount: amountValidationArray,
      },
    };

    if (activeAccSelectionMode === AccSelectionModes.Auto && isBankMode) {
      validatorPayload["keysToSkip"] = BankModeRequiredFields;
    }
    const errors = gatewayFormValidatorWithCustomErrors(validatorPayload);

    setErrors(errors);
    return errors;
  };

  /**
   *
   * @param {{event:React.ChangeEvent<HTMLInputElement>; isFile:boolean;fieldType?:string}} param0
   *
   */
  const handleWithdrawChange = ({
    event,
    isFile = false,
    fieldType = null,
  }) => {
    const name = event?.target?.name;
    const value = isFile ? event?.target?.files[0] : event?.target?.value;

    const data = { ...formdata, [name]: value };
    validateWithdrawData(data);
    setFormdata(data);
  };
  /**
   *
   * @param {React.FormEvent<HTMLFormElement>} e
   */
  const handleWithdrawSubmit = async (e) => {
    e.preventDefault();
    // Return if auto bank details tab active and bank not selected or if error
    if (
      activeAccSelectionMode === AccSelectionModes.Auto &&
      (playerBankDetails === null || !playerBankDetails?.id) &&
      isBankMode
    ) {
      Toaster(
        APP_CONST.TOAST_TYPE.ERROR,
        "Please select account from the list to continue"
      );
      return;
    }

    if (
      Object.keys(validateWithdrawData(formdata))?.length ||
      gtw?.withdrawUrl?.indexOf("dynamic") < 0
    ) {
      return;
    }

    if (playerBankDetails?.id && isBankMode) {
      formdata["bankDetailsId"] = playerBankDetails?.id;
    } else {
      delete formdata?.bankDetailsId;
    }

    if (gtw?.slug && gtw?.slug !== null) {
      formdata["slug"] = gtw?.slug;
    }

    setIsRequesting(true);

    const dataWithDefaultValues = getIfWithdrawDefaultValue({ data: formdata });

    const finalPayload = {
      ...dataWithDefaultValues,
      dynamicFields: dataWithDefaultValues,
    };
    if (
      withdrawOtpConfig.otpRequired &&
      withdrawOtpConfig?.otpSubmitted &&
      withdrawOtpConfig?.otpSent
    ) {
      finalPayload["otp"] = withdrawOtpConfig?.otpValue;
    }
    setIsRequesting(true);
    const response = await createDynamicManualWithdrawRequest({
      payload: { ...finalPayload },
      isMultiPart: gtw?.withdrawFields.some(
        (s) => s?.type === "file" || s?.type === "image"
      ),
    });
    setIsRequesting(false);
    if (response) {
      Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Request created");
    }
  };

  const AccountSelectionTabs = () => {
    return (
      <ul className="acc-selection-tabs">
        {ACC_SELECTION_TABS.map((tab, idx) => {
          return (
            <li
              key={idx}
              className={tab?.key === activeAccSelectionMode ? "active" : ""}
              onClick={() => {
                // Reset values on mode change
                setErrors({});
                setFormdata({});
                setActiveAccSelectionMode(tab.key);
                setPlayerBankDetails(null);
              }}
            >
              {tab.name}
            </li>
          );
        })}
      </ul>
    );
  };

  const getIfWithdrawDefaultValue = ({ data }) => {
    let updatedData = { ...data };
    gtw?.withdrawFields?.forEach((f) => {
      if (!Boolean(data[f?.accessor]) && Boolean(f?.value)) {
        updatedData[f?.accessor] = f?.value;
      }
    });
    return updatedData;
  };

  const handleGenerateOtp = async () => {
    setWithdrawOtpConfig((p) => ({ ...p, isSendingOtp: true }));
    const otpResponse = await requestWithdrawOtp({ slug: gtw?.slug });
    setWithdrawOtpConfig((p) => ({ ...p, isSendingOtp: false }));
    if (otpResponse) {
      Toaster(
        APP_CONST.TOAST_TYPE.SUCCESS,
        "Withdraw OTP sent on registered mobile number"
      );
      setWithdrawOtpConfig((p) => ({ ...p, otpSent: true }));
    }
  };

  const handleWTDGatewayClick = (item) => {
    // navigate(`/deposit/${item?.id}`);
    setWTDClickedGatway(item?.id);
  };

  return (
    <>
      <HeaderAfterLogin />
      <main className="main">
        {/** Two top tabs section */}
        <Container>
          <div className="d-flex justify-content-between align-items-center HeadingSection mt-4">
            <h2 className="sectionTitle">Gateways</h2>
            <div className="back-link" onClick={() => navigate(-1)}>
              Back <BackIcon />
            </div>
          </div>
          <div className="main-tabs-section mt-4">
            <Tabs
              activeKey={mainTab}
              onSelect={(key) => {
                setMainTab(key);
                // MAIN TAB CONTROLS SECOND TAB
                if (key === "deposits") {
                  setSubTab("bank");
                  setClickedGatway("bank_transfer");
                } else if (key === "withdraws") {
                  setSubTab("withdraw");
                  setClickedGatway("bank_transfer");
                  setWTDClickedGatway(gtwList[0]?.id);
                  setSelectedGateway(null);
                }
              }}
              id="deposit-withdraw-tabs"
              className="mb-3 main-tabs"
            >
              <Tab
                style={{ borderRadius: "20px" }}
                eventKey="deposits"
                title="Deposits"
              />
              <Tab
                style={{ borderRadius: "20px" }}
                eventKey="withdraws"
                title="Withdraws"
              />
            </Tabs>
          </div>
          <div className="gatewaySection">
            <div className="gatewaypart">
              <Tabs
                id="uncontrolled-tab-example"
                activeKey={subTab}
                onSelect={(key) => setSubTab(key)}
              >
                {subTab === "bank" && (
                  <Tab eventKey="bank" title="Deposit Channel">
                    {bankDetails && (
                      <div
                        className={`cards1 ${
                          clickedGatway === "bank_transfer" ? "active" : ""
                        }`}
                        onClick={() => {
                          handleBankTransferClick();
                        }}
                      >
                        {" "}
                        <div className="card-icon">
                          <img src={bankImg} style={{ width: "66px" }} />
                        </div>
                        <p style={{ color: "#333" }}>{"Bank Transfer"}</p>
                      </div>
                    )}
                    {gatewaysList?.deposits
                      ?.sort((a, b) => a?.order - b?.order)
                      .map((item, index) => {
                        const isActive = clickedGatway === item?.id;
                        return (
                          <div
                            className={`cards1 ${isActive ? "active" : ""}`}
                            onClick={() => {
                              handleGatewayClick(item);
                            }}
                            key={index}
                          >
                            <div className="card-icon">
                              <img src={item?.logo || DepositImg} />
                            </div>
                            <p style={{ color: "#333" }}>{item?.name}</p>
                          </div>
                        );
                      })}
                  </Tab>
                )}
                {subTab === "withdraw" && (
                  <Tab eventKey="withdraw" title="Payment Methods">
                    {gtwList.map((item, index) => {
                      const isActive = clickedWTDGatway === item?.id;
                      return (
                        <div
                          className={`cards1 ${isActive ? "active" : ""}`}
                          onClick={() => {
                            handleWTDGatewayClick(item);
                          }}
                          key={index}
                        >
                          <div className="card-icon">
                            <img src={item?.logo || DepositImg} />
                          </div>

                          <p style={{ color: "#333" }}>{item?.name}</p>
                        </div>
                      );
                    })}
                  </Tab>
                )}
              </Tabs>
            </div>
          </div>
        </Container>

        {/** Deposit section */}
        {mainTab === "deposits" && !isBank ? (
          <Container>
            <DisplayValues
              displayItems={selectedGateway?.depositDisplayFields || []}
            />
            {selectedGateway?.type === "manual" &&
              selectedGateway?.url !== "/deposit/pay/dynamicmanual" && (
                <>
                  <div className="valuesDeposit">
                    {/* <h3>Wallet : {selectedGateway?.value}</h3> */}
                    <h3>Wallet Number : {selectedGateway?.displayValue}</h3>

                    <div className="copyValue">
                      <CopyToClipboard
                        text={selectedGateway?.displayValue}
                        onCopy={() => {
                          Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Text Copied");
                        }}
                      >
                        <AiFillCopy />
                      </CopyToClipboard>
                      {/* <CopyToClipboard
                      text={selectedGateway?.value?.slice(index1, index2)}
                      onCopy={() => {
                        Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Text Copied");
                      }}
                    /> */}
                      <div>Click to copy code</div>
                    </div>
                  </div>
                  {(selectedGateway?.showQr === true && (
                    <div className="d-flex">
                      {showQrImg ? (
                        <div className=" mx-auto  w-full max-w-[12rem]  relative">
                          <div className="ml-4 ">
                            <div className="bg-zinc-50 rounded-lg p-3 qrSize">
                              <img src={selectedGateway?.qrCode} />
                            </div>
                          </div>
                        </div>
                      ) : (
                        <QRCodeCard text={selectedGateway?.value} />
                      )}
                    </div>
                  )) ||
                    null}
                </>
              )}
            <Form className="gatewayForm">
              <Form.Group
                className="mb-3 position-relative"
                controlId="formBasicUserName"
              >
                <Form.Control
                  type={"string"}
                  value={selectedGateway?.name}
                  disabled={true}
                />
                <span class="focus-border">
                  <i></i>
                </span>
              </Form.Group>
              {selectedGateway?.fields?.map((f, i) => {
                return renderFields(f);
              })}
              <span class="focus-border">
                <i></i>
              </span>
              <Button onClick={handleSubmit}>Submit</Button>
            </Form>
          </Container>
        ) : (
          mainTab === "deposits" && (
            <Container>
              {/* <div className="d-flex justify-content-between align-items-center HeadingSection mt-4">
              <h2 className="sectionTitle">{"Bank Transfer"}</h2>
              <div className="back-link" onClick={() => navigate(-1)}>
                Back <BackIcon />
              </div>
            </div> */}
              {bankDetails && (
                <div style={{ padding: "" }} className="BankTransferHighlights">
                  <p>
                    Account name : {bankDetails?.acc_name}{" "}
                    <CopyToClipboard
                      text={bankDetails?.acc_name}
                      onCopy={() => {
                        Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Text Copied");
                      }}
                    >
                      <AiFillCopy />
                    </CopyToClipboard>
                    {/* <CopyToClipboard
                    text={bankDetails?.acc_name}
                    onCopy={() => {
                      Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Text Copied");
                      console.log("Abc");
                    }}
                  /> */}
                  </p>
                  <p>
                    Account number : {bankDetails?.acc_no}{" "}
                    <CopyToClipboard
                      text={bankDetails?.acc_no}
                      onCopy={() => {
                        Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Text Copied");
                      }}
                    >
                      <AiFillCopy />
                    </CopyToClipboard>
                    {/* <CopyToClipboard
                    text={bankDetails?.acc_no}
                    onCopy={() => {
                      Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Text Copied");
                    }}
                  /> */}
                  </p>
                  <p>
                    IFSC code : {bankDetails?.ifsc_code}{" "}
                    <CopyToClipboard
                      text={bankDetails?.ifsc_code}
                      onCopy={() => {
                        Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Text Copied");
                      }}
                    >
                      <AiFillCopy />
                    </CopyToClipboard>
                    {/* <CopyToClipboard
                    text={bankDetails?.ifsc_code}
                    onCopy={() => {
                      Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Text Copied");
                    }}
                  /> */}
                  </p>
                  <p>
                    Bank name : {bankDetails?.bank_name}{" "}
                    <CopyToClipboard
                      text={bankDetails?.bank_name}
                      onCopy={() => {
                        Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Text Copied");
                      }}
                    >
                      <AiFillCopy />
                    </CopyToClipboard>
                    {/* <CopyToClipboard
                    text={bankDetails?.bank_name}
                    onCopy={() => {
                      Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Text Copied");
                    }}
                  /> */}
                  </p>
                </div>
              )}
              {bankDetails && renderBankTransferForm()}
            </Container>
          )
        )}

        {/** Withdraw section */}
        {mainTab === "withdraws" ? (
          <main className="main mt-4">
            <Container>
              {!withdrawOtpConfig?.otpRequired ||
              (withdrawOtpConfig?.otpRequired &&
                withdrawOtpConfig?.otpSubmitted) ? (
                <>
                  <div className="withdrawinnerpage">
                    <DisplayValues
                      displayItems={gtw?.withdrawDisplayFields || []}
                    />
                    {isBankMode && (
                      <>
                        <AccountSelectionTabs />
                        <div
                          className={
                            activeAccSelectionMode === AccSelectionModes.Auto
                              ? "WithDrawSection"
                              : "WithDrawSection d-none"
                          }
                        >
                          <ListBankDetails
                            setPlayerBankId={setPlayerBankDetails}
                            setAutoPopulateBankDetails={() => {}}
                          />
                        </div>
                      </>
                    )}
                    {isBankMode &&
                    activeAccSelectionMode === AccSelectionModes.AddAccount ? (
                      <PlayerBankDetailsForm />
                    ) : (
                      <Form
                        className="gatewayForm py-1"
                        onSubmit={handleWithdrawSubmit}
                        style={{
                          paddingLeft: "5.5rem",
                          paddingRight: "5.5rem",
                        }}
                      >
                        {gtw?.withdrawFields?.map((f, i) => {
                          return (
                            <GatewayFields
                              key={i}
                              field={f}
                              index={i}
                              handleChange={handleWithdrawChange}
                              formData={formdata}
                              errors={errors}
                              hideFieldManually={
                                activeAccSelectionMode ==
                                  AccSelectionModes.Auto &&
                                f?.accessor !== "amount" &&
                                BankModeRequiredFields.includes(f?.accessor)
                              }
                            />
                          );
                        })}
                        <span className="focus-border">
                          <i></i>
                        </span>
                        <div className="gap-2">
                          <Button
                            type="submit"
                            style={{ width: "100%" }}
                            disabled={
                              isRequesting ||
                              (withdrawOtpConfig?.otpRequired &&
                                !withdrawOtpConfig?.otpSent)
                            }
                          >
                            {isRequesting ? "Loading..." : "Submit"}
                          </Button>
                          {withdrawOtpConfig?.otpRequired && (
                            <Button
                              style={{ width: "100%" }}
                              onClick={() => {
                                setWithdrawOtpConfig((p) => ({
                                  ...p,
                                  otpSent: false,
                                  otpSubmitted: false,
                                }));

                                setFormdata({});
                              }}
                              className=""
                            >
                              Re Send OTP
                            </Button>
                          )}
                          <Button
                            style={{ width: "100%", marginTop: "2px" }}
                            onClick={() => navigate("/withdrawList")}
                          >
                            View Request
                          </Button>
                        </div>
                      </Form>
                    )}
                  </div>
                </>
              ) : (
                <>
                  {" "}
                  {/* <div className="PagesHeading">
                  <h4>{gtw?.name}</h4>
                  <div className="back-link" onClick={() => navigate(-1)}>
                    <BackIcon /> Back
                  </div>
                </div> */}
                  <PreWithdrawForm
                    onGenerateOtp={handleGenerateOtp}
                    withdrawOtpConfig={withdrawOtpConfig}
                    onSubmit={(otp) => {
                      setWithdrawOtpConfig((p) => ({
                        ...p,
                        otpValue: otp,
                        otpSubmitted: true,
                      }));
                    }}
                  />
                </>
              )}
            </Container>
          </main>
        ) : (
          mainTab === "withdraws" && (
            <div className="WithdrawList">
              <Container>
                {/* <h4 className="headingSec">{gtw?.name}</h4> */}
                <DisplayValues
                  displayItems={gtw?.withdrawDisplayFields || []}
                />
                <Form className="gatewayForm" onSubmit={handleWithdrawSubmit}>
                  {gtw?.withdrawFields?.map((f, i) => {
                    return (
                      <GatewayFields
                        key={i}
                        field={f}
                        index={i}
                        handleChange={handleWithdrawChange}
                        formData={formdata}
                        errors={errors}
                      />
                    );
                  })}
                  <span className="focus-border">
                    <i></i>
                  </span>

                  <Button type="submit" disabled={isRequesting}>
                    {isRequesting ? "Loading..." : "Submit"}
                  </Button>
                </Form>
              </Container>
            </div>
          )
        )}
      </main>
      <Footer />
    </>
  );
};
export default DepositGateway;
